// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1573":"bf1adb39","2510":"bf1adb39","5731":"0d4588ac","9972":"0d4588ac"}[chunkId] + ".chunk.css";
};